<template>
  <Card :title="$t('global.bandwidth')">
    <LoadingState v-if="isLoading()" :size="50" />
    <ErrorState v-else-if="isErrored()" />
    <template>
      <LoadingState v-if="status.isLoading" :size="50" />
      <EmptyState v-else-if="!chart" :message="$t('global.no-traffic-data')" />
      <LineChart
        v-if="status.isLoaded && chart"
        :labels="chart.labels"
        :lines="chart.lines"
        :yAxesUnit="chart.yAxesUnit"
      />
    </template>
  </Card>
</template>

<script>
import { computed, onMounted } from "@vue/composition-api";
import Card from "@/components/display/Card";
import EmptyState from "@/components/display/empty-state/EmptyState";
import ErrorState from "@/components/display/ErrorState";
import LineChart from "@/components/display/LineChart";
import LoadingState from "@/components/display/LoadingState";
import store from "@/store";

export default {
  name: "Bandwidth",
  components: {
    Card,
    EmptyState,
    ErrorState,
    LineChart,
    LoadingState,
  },
  props: {
    plan: Object,
    planStatus: {
      type: Object,
      required: true,
    },
    site: Object,
    siteStatus: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const chart = computed(() => {
      const chart = store.getters["chart/getBandwidth"];
      if (!chart) return chart;
      if (chart.lines?.length >= 2) {
        chart.lines[0].backgroundColor = "rgba(255, 166, 68, 0.2)";
        chart.lines[1].backgroundColor = "rgba(44, 126, 205, 0.2)";
      }
      return chart;
    });
    const status = computed(() => store.getters["chart/getBandwidthStatus"]);

    const isErrored = () => props.planStatus.isErrored || props.siteStatus.isErrored;
    const isLoading = () => props.planStatus.isLoading || props.siteStatus.isLoading;

    onMounted(() => {
      store.dispatch("chart/getBandwidth", props.plan.id);
    });

    return {
      chart,
      isErrored,
      isLoading,
      status,
    };
  },
};
</script>
